<template>
  <div class="o-modal">
    <div class="o-modal-content">
      <div class="o-modal-header">
        <a
          @click="$store.commit('setStateProperty', { property: 'subLayerPicker', value: false })"
          class="close clickable"
        ><i class="far fa-times"></i></a>
        <p class="lead">Choose a Sublayer Dataset</p>
      </div>
      <div class="o-modal-body">
        <div id="dataset-picker" class="card p-1">
          <div
            class="mb-2"
          >
            <span
              v-for="(crumb, i) in breadcrumbs"
              v-bind:key="i"
            >
              <b-badge
                pill
                variant="primary"
                @click="launchFolder(crumb, true)"
                class="clickable"
              >{{ crumb.name }}</b-badge><span v-if="(i + 1) !== breadcrumbs.length"> / </span>
            </span>
          </div>
          <!-- FOLDERS -->
          <div class="list-group mb-2 folders" v-if="!loadingFolders">
            <div
              v-for="(folder, i) in folders"
              v-bind:key="i"
              class="list-container"
            >
              <a
                @click="launchFolder(folder)"
                class="list-group-item list-group-item-action clickable mb-2 folder"
              >
                <p class="lead mb-1"><i class="fas fa-folder"></i> {{ folder.name }}</p>
                <p class="mb-1">{{ folder.description }}</p>
              </a>
            </div>
          </div><!-- /.list-group -->
          <!-- DATASETS -->
          <div class="list-group sets" v-if="!loadingDatasets">
            <div
            v-for="(datasetItem, i) in this.datasets"
            v-bind:key="i"
            class="list-container"
            >
              <a
                @click="launchDataset(datasetItem)"
                class="list-group-item list-group-item-action clickable handle mb-2"
                v-if="datasetItem.id !== dataset.id"
              >
                <p class="lead mb-1"><i v-if="datasetItem.dynamic" class="fas fa-satellite-dish" v-b-tooltip.hover.top="'Dynamic Dataset'"></i> {{ datasetItem.name }}</p>
                <p class="mb-1">{{ datasetItem.description }}</p>
              </a>
              <a
                class="list-group-item list-group-item-action handle mb-2"
                v-else
              >
                <p class="lead mb-1"><i v-if="datasetItem.dynamic" class="fas fa-satellite-dish" v-b-tooltip.hover.top="'Dynamic Dataset'"></i> {{ datasetItem.name }}</p>
                <p class="mb-1">{{ datasetItem.description }}</p>
                <div class="inactive-overlay"></div>
              </a>
            </div>
          </div><!-- /.list-group -->
        </div><!-- /#dataset-picker -->
      </div>
    </div>
  </div><!-- /.o-modal -->
</template>

<script>
const fb = require('../../firebaseConfig.js')

export default {
  data () {
    return {
      breadcrumbs: [
        {
          id: 'root',
          name: 'Root'
        }
      ],
      datasets: [],
      folder: {
        id: 'root',
        name: 'Root'
      },
      folders: [],
      lastVisibleDataset: {},
      loadingFolders: true,
      loadingDatasets: true
    }
  },
  computed: {
    dataset: {
      get () {
        return this.$store.state.dataset
      },
      set (value) {
        this.$store.commit('setStateProperty', { property: 'dataset', value: value })
      }
    }
  },
  created () {
    this.fetchDatasets()
    this.fetchFolders()
  },
  methods: {
    fetchDatasets () {
      this.loadingDatasets = true
      let order = 'createdOn'
      let direction = 'desc'
      const state = this.$store.state
      if (state.paginate === false) {
        this.datasets = []
      }
      if (state.sortBy === 'Most Recent') {
        order = 'updatedOn'
        direction = 'desc'
      } else if (state.sortBy === 'Oldest') {
        order = 'updatedOn'
        direction = 'asc'
      } else if (state.sortBy === 'Name A-Z') {
        order = 'name'
        direction = 'asc'
      } else if (state.sortBy === 'Name Z-A') {
        order = 'name'
        direction = 'desc'
      }
      let datasetsQuery
      if (this.datasets.length < 1) {
        datasetsQuery = fb.datasetsCollection.where('farmId', '==', state.farm.id).where('folderId', '==', this.folder.id).orderBy(order, direction).limit(30)
      } else {
        const lastVisible = this.lastVisibleDataset
        datasetsQuery = fb.datasetsCollection.where('farmId', '==', state.farm.id).where('folderId', '==', this.folder.id).orderBy(order, direction).startAfter(lastVisible).limit(30)
      }
      datasetsQuery.get().then(snapshots => {
        if (state.paginate === false) {
          this.datasets = []
        }
        this.lastVisibleDataset = snapshots.docs[snapshots.docs.length - 1]
        snapshots.forEach(doc => {
          const item = doc.data()
          item.id = doc.id
          this.datasets.push(item)
        })
        this.$store.commit('setStateProperty', { property: 'paginate', value: false })
        this.loadingDatasets = false
        return true
      }).catch(err => {
        console.log(err)
        return false
      })
    },
    fetchFolders () {
      this.loadingFolders = true
      const farmId = this.$store.state.farm.id
      this.folders = []
      fb.foldersCollection.where('farmId', '==', farmId).where('folderId', '==', this.folder.id).orderBy('name', 'asc').get().then(docs => {
        docs.forEach(doc => {
          const folder = doc.data()
          folder.id = doc.id
          this.folders.push(folder)
        })
        this.loadingFolders = false
        return true
      }).catch(err => {
        console.log(err)
        return false
      })
    },
    launchFolder (folder, fromCrumb) {
      if (this.breadcrumbs.length < 1) {
        this.breadcrumbs = [{ name: 'Root', id: 'root' }]
      }
      if (fromCrumb) {
        const newBreadcrumbs = []
        this.breadcrumbs.some(crumb => {
          if (crumb.id !== folder.id) {
            newBreadcrumbs.push(crumb)
          } else {
            newBreadcrumbs.push(crumb)
            return true
          }
        })
        this.breadcrumbs = newBreadcrumbs
      } else {
        this.breadcrumbs.push(folder)
      }
      this.folder = folder
      this.fetchDatasets()
      this.fetchFolders()
    },
    launchDataset (dataset) {
      // Datasets that have never had their viz settings saved — dynamic
      // (collector-backed) datasets in particular — carry no vizSettings on
      // their stored doc. Writing `.subLayer` onto that undefined threw
      // "Cannot set properties of undefined (setting 'subLayer')", which broke
      // using or adding these datasets as sub-layers. Default it first.
      if (!dataset.vizSettings) this.$set(dataset, 'vizSettings', {})
      if (!this.dataset.vizSettings) this.$set(this.dataset, 'vizSettings', {})
      // Assign this dataset to the current dataset sublayer
      dataset.vizSettings.subLayer = false
      this.dataset.vizSettings.subLayer = dataset
      // Tell component that the sublayer has been updated
      this.$emit('updatedSubLayer')
      // Hide the picker
      this.$store.commit('setStateProperty', { property: 'subLayerPicker', value: false })
    }
  }
}
</script>

<style scoped>
.card > .list-group {
  border-top: none;
  border-bottom: none;
}
.folder {
  background-color: #eee;
}

.badge.clickable:hover {
  box-shadow: 1px 2px 4px rgba(0,0,0,0.5);
}

.o-modal {
  z-index: 51;
}

.inactive-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,0.5);
}
</style>
